// Read-only config constants. Don't mutate because this structure is not
// reactive--components will not update.
const config = {
  requestWidths: [750, 1080, 1440, 2880],
  prefetchBackward: 1,
  prefetchForward: 3,
  keepBackward: 3,
  keepForward: 5,
}

export default Object.freeze(config)
